import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  BGColor02,
  blackColor,
  blackShade21,
  blackShade22,
  blueColor04,
  greenColor02,
  greyColor40,
  greyShade13,
  mobilePrimary,
  whiteColor,
} from "../../configs/styles/muiThemes";
import {
  getActiveBusinessInfo,
  getCommerceInfo,
} from "../../reducers/businessPreview/businessPreviewSlice";
import { updateCommerceSubmitAPI } from "../../service/api_calls/BusinessOnboard/BusinessOnboardingAPI";
import DashboardLayout from "../../components/Layouts/DashboardLayout";
import { stickyHeader } from "../../utils/styles";
import {
  ECOMINPUTSUPPORTLABEL,
  emailAddress,
  whatsAppNumber,
} from "../../configs/Constants";
import DashboardStepper from "../Dashboard/DashboardStepper";
import { ECOMMERCE_STEP_LIST } from "../../utils/appData";
import SelectWithLabel from "../../components/Input/SelectWithLabel";
import FormInputBox from "../../components/Input/FormInputBox";
import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  catalogPartnerAddAuth,
  catalogPartnerBulkAddAuth,
  catalogPartnerGetAuth,
  getBuyMoreAuthAndWareHouseApi,
  getUnicomerceFacilityInfo,
} from "../../service/api_calls/CatalogSync/CatalogSyncApi";
import { prepareUpdateCatalogControlPostData } from "../../service/api_calls/CatalogSync/CatalogSyncHelper";
import { toTitleCase } from "../../utils/validationUtils";
import ThreeDotLoader from "../../components/ThreeDotLoader";
import { getBranchInfoAPI } from "../../service/api_calls/multiBranchCatalog/multiBranchCatalogAPIs";

function EditCatalogControls({ type }) {
  const businessId = sessionStorage.getItem("selectedBusinessId");
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));

  const CATALOG_PARTNERS = [
    { label: "Select Catalog Partner", value: "Select Catalog Partner" },
    { label: "Unicommerce", value: "Unicommerce" },
    { label: "BuyMore", value: "BuyMore" },
  ];

  const [buymoreWarehouseInfoList, setBuyMoreWarehouseList] = useState([
    { label: "Select Warehouse", value: "Select Warehouse", code: -1 },
  ]);

  const [selectedWarehouse, setSelectedWarehouse] = useState({
    label: "Select Warehouse",
    value: "Select Warehouse",
    code: -1,
  });

  const location = useLocation();
  const activeTab = "catalog-controls";

  const [controlInfo, setControlInfo] = useState({
    catalogPartner: "",
    apiKey: "",
    username: "",
    password: "",
    baseUrl: "",
    channelCode: "",
    facilityName: "",
    facilityCode: "",
    token: "",
    warehouses: [{ name: "", code: "" }],
    allSkuSelected: "none",
    skuList: [],
  });

  const [showPassword, setShowPassword] = useState(false);
  const [isCredentialsVerified, setIsCredentialsVerified] = useState(false);
  const [isFacilityCodeValid, setIsFacilityCodeValid] = useState(false);

  const [verifyLoader, setVerifyLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [isSubBranch, setIsSubBranch] = useState(false);

  const contentRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    activeBusinessInfo,
    commerceInfo,
    activeBusinessInfoLoader,
    commerceInfoLoader,
  } = useSelector((state) => state.businessPreview);

  const [isEdit, setIsEdit] = useState(false);

  const handleSetValue = (name, value) => {
    setControlInfo((prevState) => ({
      ...prevState,
      [name]: value,
      errors: {
        ...prevState?.errors,
        [name]: "",
      },
    }));
  };

  // Whatsapp chat click
  const handleChatClick = () => {
    if (whatsAppNumber) {
      window.open(
        `https://api.whatsapp.com/send/?phone=${whatsAppNumber}&text=${activeBusinessInfo?.name}+- E-Commerce Controls+-+Support+Request.+`,
        "_blank"
      );
    } else {
      window.fcWidget.open();
      window.fcWidget.show();
    }
  };

  const getCatalogPartnerAuth = async () => {
    const res = await catalogPartnerGetAuth({
      businessId,
      catalogPartner: controlInfo?.catalogPartner?.toLowerCase(),
    });

    if (controlInfo?.catalogPartner?.toLowerCase() == "buymore") {
      const params = new URLSearchParams();
      params.append("catalogPartner", "buymore");

      const res = await getBuyMoreAuthAndWareHouseApi(params, businessId);

      const warehouseList = res?.warehouse || [];

      const warehouseDropdownList = warehouseList?.map((item) => ({
        label: item.warehouse_name,
        value: item.warehouse_name,
        code: item.warehouse_id,
      }));

      console.log("TEST____warehouseDropdownList", { warehouseDropdownList });

      setBuyMoreWarehouseList((prevState) => [
        ...prevState,
        ...warehouseDropdownList,
      ]);
    }

    if (res?.businessId == businessId) {
      setIsCredentialsVerified(true);
    } else {
      setIsCredentialsVerified(false);
    }

    setVerifyLoader(false);
  };

  // handle verify credentials
  const verifyCredentials = async () => {
    const { catalogPartner, username, password, baseUrl, channelCode } = controlInfo || {};
    const errors = {};

    if (!catalogPartner || catalogPartner === "Select Catalog Partner") {
      errors.catalogPartner = "Choose catalog partner";
    }

    if (!username) {
      errors.username = "Enter Username";
    }

    if (!password) {
      errors.password = "Enter Password";
    }

    if (
      controlInfo?.catalogPartner?.toLowerCase() == "unicommerce" &&
      !baseUrl
    ) {
      errors.baseUrl = "Enter Base Url";
    }
    
    if (
      controlInfo?.catalogPartner?.toLowerCase() == "unicommerce" &&
      !channelCode
    ) {
      errors.channelCode = "Enter Channel Code";
    }

    if (Object.keys(errors).length > 0) {
      setControlInfo((prevState) => ({
        ...prevState,
        errors,
      }));
      return;
    }

    setControlInfo((prevState) => ({
      ...prevState,
      errors: null,
    }));

    // setVerifyLoader(true);

    const postData = {
      businessId: businessId,
      userId: username,
      password: password,
      catalogPartner: catalogPartner?.toLowerCase() || "",
      baseURL: baseUrl,
      channel: channelCode,
      status: "active",
    };

    console.log("AUTH___postData", postData);

    const res = await catalogPartnerAddAuth(postData);

    if (res?.success) {
      getCatalogPartnerAuth();
      return;
    } else {
      let errorMsg =
        res?.success === false
          ? res?.details?.message
          : "Something went wrong. Please try again.";

      if (
        errorMsg ==
        "Unable to retrieve access token. Please check the username and password."
      ) {
        errorMsg = "Invalid Credentials";
      }

      if (
        errorMsg ==
        "A CatalogPartnerAuth with the given businessId and catalogPartner already exists."
      ) {
        getCatalogPartnerAuth();
      } else {
        setControlInfo((prevState) => ({
          ...prevState,
          errors: { ...prevState?.errors, authErr: errorMsg },
        }));
        setIsCredentialsVerified(false);
        setVerifyLoader(false);
      }
    }
  };

  // Validate Unicommerce FacilityCode
  const validateUnicommerceFacilityCode = async (
    facilityName,
    facilityCode
  ) => {
    try {
      setVerifyLoader(true);

      const params = new URLSearchParams();
      params.append("catalogPartner", "unicommerce");
      params.append("facility", facilityName);
      params.append("facilityCode", facilityCode);

      const res = await getUnicomerceFacilityInfo(params, businessId);

      if (res?.facility?.code == facilityCode) {
        setControlInfo((prevState) => ({
          ...prevState,
          facilityName: res.facility?.name || "",
          errors: null,
        }));
        setIsFacilityCodeValid(true);
        return true;
      } else {
        setControlInfo((prevState) => ({
          ...prevState,
          errors: {
            ...prevState?.errors,
            facilityCode: "Invaid Facility Code",
          },
        }));
        setIsFacilityCodeValid(false);
        return false;
      }
    } catch (error) {
      const errorMsg =
        error?.response?.data?.successful === false
          ? "Invaid Facility Code"
          : "Something went wrong. Please try again.";

      setControlInfo((prevState) => ({
        ...prevState,
        errors: { ...prevState?.errors, facilityCode: errorMsg },
      }));
      setIsFacilityCodeValid(false);
      return false;
    } finally {
      setVerifyLoader(false);
    }
  };

  // Validate BuyMore Warehouse code
  const validateBuyMoreFacilityCode = async (facilityCode) => {
    try {
      setVerifyLoader(true);

      const params = new URLSearchParams();
      params.append("catalogPartner", "buymore");

      const res = await getBuyMoreAuthAndWareHouseApi(params, businessId);

      if (res?.warehouse?.length > 0) {
        const warehouseList = res?.warehouse || [];
        const warehouseInfo = warehouseList?.find(
          (item) => item?.warehouse_id == facilityCode
        );

        if (warehouseInfo) {
          setControlInfo((prevState) => ({
            ...prevState,
            facilityName: warehouseInfo.warehouse_name || "",
            errors: null,
          }));
          setIsFacilityCodeValid(true);
          return true;
        } else {
          setControlInfo((prevState) => ({
            ...prevState,
            errors: {
              ...prevState?.errors,
              facilityCode: "Invaid Facility Code",
            },
          }));
          setIsFacilityCodeValid(false);
          return false;
        }
      } else {
        setControlInfo((prevState) => ({
          ...prevState,
          errors: {
            ...prevState?.errors,
            facilityCode: "Invaid Facility Code",
          },
        }));
        setIsFacilityCodeValid(false);
        return false;
      }
    } catch (error) {
      const errorMsg =
        error?.response?.data?.successful === false
          ? "Invaid Facility Code"
          : "Something went wrong. Please try again.";

      setControlInfo((prevState) => ({
        ...prevState,
        errors: { ...prevState?.errors, facilityCode: errorMsg },
      }));
      setIsFacilityCodeValid(false);
      return false;
    } finally {
      setVerifyLoader(false);
    }
  };

  // handle facility info
  const verifyFacilityInfo = async () => {
    const { facilityName, facilityCode } = controlInfo || {};

    if (!facilityCode) {
      setControlInfo((prevState) => ({
        ...prevState,
        errors: { ...prevState.errors, facilityCode: "Enter facility code" },
      }));
      return;
    }

    if (controlInfo?.catalogPartner?.toLowerCase() == "unicommerce") {
      validateUnicommerceFacilityCode(facilityName, facilityCode);
    } else {
      validateBuyMoreFacilityCode(facilityCode);
    }
  };

  const handleSubmit = async () => {
    const { catalogPartner, username, password, facilityCode } =
      controlInfo || {};

    const errors = {};

    if (!isSubBranch) {
      // Validation checks
      if (!catalogPartner || catalogPartner === "Select Catalog Partner") {
        errors.catalogPartner = "Choose catalog partner";
      }

      if (!username) {
        errors.username = "Enter username";
      }

      if (!password) {
        errors.password = "Enter password";
      }
    }

    if (!facilityCode) {
      errors.facilityCode = "Enter facility code";
    }

    if (facilityCode && !isFacilityCodeValid) {
      errors.facilityCode = "Enter valid facility code";
    }

    // Handle errors or proceed to submit
    if (
      Object.keys(errors).length > 0 ||
      !isFacilityCodeValid ||
      !isCredentialsVerified
    ) {
      setControlInfo((prevState) => ({
        ...prevState,
        errors,
      }));
      return;
    }

    setIsLoading(true);

    const postData = prepareUpdateCatalogControlPostData({
      commerceInfo: commerceInfo?.info || null,
      catalogPartnerInfo: {
        catalogPartner: controlInfo?.catalogPartner?.toLowerCase(),
        facilityName: controlInfo?.facilityName,
        facilityCode: controlInfo?.facilityCode,
      },
    });

    const responce = await updateCommerceSubmitAPI(postData, businessId);

    // Check If Master Branch and Add Auth to All Sub-Branches
    const isMainBranch =
      activeBusinessInfo?.mainBranch && !activeBusinessInfo?.mainBranchId;

    if (isMainBranch) {
      const branchListData = await getBranchInfoAPI(businessId);
      const subBranchList = branchListData?.details?.branchInfo?.filter(
        (item) => item?.status == "active"
      );

      const postData = {
        businessId: subBranchList?.map((item) => item?.branchId),
        userId: username,
        password: password,
        catalogPartner: catalogPartner?.toLowerCase() || "",
        status: "active",
      };

      const res = await catalogPartnerBulkAddAuth(postData);
    }

    if (responce) {
      setIsLoading(false);
      dispatch(getCommerceInfo(businessId));
      const businessUrl = sessionStorage.getItem("costboWEBURL");
      navigate(`/${businessUrl}/catalogControls`);
    }
  };

  const prepareAutoFill = async () => {
    const catalogPartnerObj =
      commerceInfo?.info?.catalogPartnerInfo?.[0] || null;

    const catalogPartnerStr = catalogPartnerObj?.catalogPartner || "";
    const warehouseInfo = catalogPartnerObj?.warehouse || null;

    const warehouseName = warehouseInfo?.facilityName || "";
    const warehouseCode = warehouseInfo?.facilityCode || "";

    if (catalogPartnerStr) {
      const authData = await catalogPartnerGetAuth({
        businessId,
        catalogPartner: catalogPartnerStr?.toLowerCase(),
      });

      if (authData?.businessId == businessId) {
        setControlInfo((prevState) => ({
          ...prevState,
          catalogPartner:
            catalogPartnerStr == "buymore"
              ? "BuyMore"
              : toTitleCase(catalogPartnerStr || "Select Catalog Partner"),
          baseUrl: authData?.baseURL,
          channelCode: authData?.channel,
          username: authData?.userId,
          facilityName: warehouseName,
          facilityCode: warehouseCode,
        }));

        // Check if sub-branch
        const validSubBranch =
          !activeBusinessInfo?.mainBranch && activeBusinessInfo?.mainBranchId;

        if (validSubBranch) {
          setIsFacilityCodeValid(warehouseCode ? true : false);
          setIsCredentialsVerified(true);
          setIsEdit(true);
          setIsSubBranch(validSubBranch);
          return;
        }

        if (warehouseCode) {
          setIsFacilityCodeValid(true);
          setIsEdit(true);
        }
      }
    }
  };

  useEffect(() => {
    if (commerceInfo && activeBusinessInfo) {
      prepareAutoFill();
    }

    return () => {};
  }, [commerceInfo, activeBusinessInfo]);

  useEffect(() => {
    if (businessId) {
      if (!activeBusinessInfo) {
        dispatch(getActiveBusinessInfo(businessId));
        dispatch(getCommerceInfo(businessId));
      }
    }
  }, []);

  return (
    <Box sx={styles.container}>
      {activeBusinessInfo && commerceInfo ? (
        <DashboardLayout>
          <Box ref={contentRef} sx={styles.content}>
            <Box sx={stickyHeader} pb={1.5}>
              <Typography
                component="h6"
                fontSize={{ xs: 15, md: 17 }}
                color={blackColor}
                fontWeight={600}
                lineHeight="20px"
                pt={{ xs: 1, md: 0 }}
                mb={"4px !important"}
              >
                <span
                  style={{
                    color: matches ? blueColor04 : mobilePrimary,
                    marginRight: "5px",
                  }}
                >
                  {type === "Add" ? "Add" : "Edit"}
                </span>{" "}
                E-Commerce Details
              </Typography>

              <Typography
                variant="h6"
                fontSize={13}
                fontWeight={500}
                color={blackShade21}
                lineHeight={"20px"}
                // display="inline"
                // mb="15px"
              >
                {ECOMINPUTSUPPORTLABEL}{" "}
                <Typography
                  // variant="body1"
                  fontSize={13}
                  fontWeight={500}
                  color={{ xs: mobilePrimary, md: blueColor04 }}
                  display="inline"
                  // onclick={handleChatClick}
                  component="a"
                  href={`https://mail.google.com/mail/u/0/?cc=&subject=yourSubject&su=${activeBusinessInfo?.name}+- E-Commerce Controls+-+Support+Request.+&fs=1&to=${emailAddress}&tf=cm`}
                  target="_blank"
                >
                  Email
                </Typography>
                {"  "}
                or{" "}
                <Typography
                  // variant="body1"
                  fontSize={13}
                  fontWeight={500}
                  color={{ xs: mobilePrimary, md: blueColor04 }}
                  sx={{ cursor: "pointer" }}
                  display="inline"
                  onClick={handleChatClick}
                >
                  Whatsapp
                </Typography>
              </Typography>

              <DashboardStepper
                stepList={ECOMMERCE_STEP_LIST}
                currentPage={"catalog-controls"}
                isAddProduct
              />

              <Box m="15px 0 15px 0">
                <Typography
                  component="h6"
                  fontSize={{ xs: 14.5, md: 15 }}
                  color={blackColor}
                  fontWeight={600}
                  lineHeight="20px"
                  mb="12px !important"
                >
                  Catalog Controls
                </Typography>

                <Box sx={styles.card}>
                  {!activeBusinessInfoLoader && !commerceInfoLoader ? (
                    <>
                      <Box width={{ xs: "auto", md: "300px" }}>
                        <Typography
                          component="h6"
                          fontSize={{ xs: 13.5, md: 14 }}
                          color={blackColor}
                          fontWeight={600}
                          lineHeight="20px"
                          mb={1}
                        >
                          Catalog Partner
                        </Typography>

                        <SelectWithLabel
                          label="Catalog Partner"
                          menuList={CATALOG_PARTNERS}
                          value={
                            controlInfo?.catalogPartner ||
                            "Select Catalog Partner"
                          }
                          onValueChange={(value) => {
                            handleSetValue("catalogPartner", value);
                          }}
                          errorMsg={controlInfo?.errors?.catalogPartner}
                          disabled={isFacilityCodeValid || isSubBranch}
                        />
                      </Box>

                      {!controlInfo?.catalogPartner ||
                        (controlInfo?.catalogPartner !==
                          "Select Catalog Partner" && (
                          <Box mt={2.5}>
                            <Typography
                              component="h6"
                              fontSize={{ xs: 13.5, md: 14 }}
                              color={blackColor}
                              fontWeight={600}
                              lineHeight="20px"
                              mb={{
                                xs: "6px !important",
                                md: "8px !important",
                              }}
                            >
                              Credential for {controlInfo?.catalogPartner}
                            </Typography>

                            <Grid
                              container
                              spacing={{ xs: 1.5, md: 3 }}
                              alignItems="flex-start"
                            >
                              {controlInfo?.catalogPartner?.toLowerCase() ==
                                "unicommerce" && (
                                <>
                                  <Grid item xs={12} md={3.2}>
                                    <FormInputBox
                                      label="Base Url"
                                      placeholder=""
                                      value={controlInfo?.baseUrl}
                                      onChange={({ target }) => {
                                        handleSetValue(
                                          "baseUrl",
                                          target?.value
                                        );
                                      }}
                                      error={controlInfo?.errors?.baseUrl}
                                      disabled={
                                        isCredentialsVerified ||
                                        isFacilityCodeValid ||
                                        isSubBranch
                                      }
                                      autoComplete="off"
                                    />
                                  </Grid>
                                  <Grid item xs={12} md={3.2}>
                                    <FormInputBox
                                      label="Channel Code"
                                      placeholder=""
                                      value={controlInfo?.channelCode}
                                      onChange={({ target }) => {
                                        handleSetValue(
                                          "channelCode",
                                          target?.value
                                        );
                                      }}
                                      error={controlInfo?.errors?.channelCode}
                                      disabled={
                                        isCredentialsVerified ||
                                        isFacilityCodeValid ||
                                        isSubBranch
                                      }
                                      autoComplete="off"
                                    />
                                  </Grid>{" "}
                                  <Grid item xs={12} md={4}></Grid>{" "}
                                </>
                              )}

                              <Grid item xs={12} md={3.2}>
                                <FormInputBox
                                  label="Username"
                                  placeholder=""
                                  value={controlInfo?.username}
                                  onChange={({ target }) => {
                                    handleSetValue("username", target?.value);
                                  }}
                                  error={controlInfo?.errors?.username}
                                  disabled={
                                    isCredentialsVerified ||
                                    isFacilityCodeValid ||
                                    isSubBranch
                                  }
                                  autoComplete="off"
                                />
                              </Grid>

                              {!isSubBranch && (
                                <>
                                  <Grid item xs={12} md={3}>
                                    <FormInputBox
                                      label="Password"
                                      placeholder=""
                                      value={controlInfo?.password}
                                      onChange={({ target }) => {
                                        handleSetValue(
                                          "password",
                                          target?.value
                                        );
                                      }}
                                      inputType={
                                        showPassword ? "text" : "password"
                                      }
                                      error={controlInfo?.errors?.password}
                                      icon={
                                        <Box
                                          onClick={() => {
                                            setShowPassword(!showPassword);
                                          }}
                                        >
                                          {showPassword ? (
                                            <RemoveRedEyeOutlinedIcon
                                              sx={{ fontSize: "20px" }}
                                            />
                                          ) : (
                                            <VisibilityOffOutlinedIcon
                                              sx={{ fontSize: "20px" }}
                                            />
                                          )}{" "}
                                        </Box>
                                      }
                                      disabled={isCredentialsVerified}
                                      autoComplete="off"
                                    />
                                  </Grid>

                                  <Grid item xs={10} md={2}>
                                    <Box mt={2.4}>
                                      <VerifyBtn
                                        isVerified={isCredentialsVerified}
                                        handleVerifyClick={verifyCredentials}
                                        isLoading={verifyLoader}
                                      />
                                    </Box>
                                  </Grid>
                                </>
                              )}
                            </Grid>

                            {controlInfo?.errors?.authErr ? (
                              <Typography
                                variant="subtitle1"
                                component="p"
                                fontSize={12}
                                sx={{
                                  m: "-10px 0 10px !important",
                                  textAlign: "start !important",
                                }}
                                style={{ color: "red" }}
                              >
                                {controlInfo?.errors?.authErr}
                              </Typography>
                            ) : null}
                          </Box>
                        ))}

                      {(isCredentialsVerified || isEdit) && (
                        <>
                          <Box mt={0}>
                            <Typography
                              component="h6"
                              fontSize={{ xs: 13.5, md: 14 }}
                              color={blackColor}
                              fontWeight={600}
                              lineHeight="20px"
                              mb={{
                                xs: "6px !important",
                                md: "0px !important",
                              }}
                            >
                              Warehouse
                            </Typography>

                            <Typography
                              fontSize={{ xs: 12, md: 13 }}
                              fontWeight={400}
                              color={greyColor40}
                              mb={0.8}
                              lineHeight={{ xs: "20px", md: "24px" }}
                            >
                              {/* {controlInfo?.catalogPartner == "Unicommerce"
                                ? `You can find all your Unicommerce warehouse codes (facility codes) by navigating to Settings > Facilities in your Unicommerce dashboard.`
                                : "You can find all your BuyMore warehouse codes by navigating to Settings > Facilities in your BuyMore dashboard."} */}

                              {`Get the facility code from ${controlInfo?.catalogPartner} dashboard`}
                            </Typography>

                            <Box>
                              <Grid
                                container
                                spacing={{
                                  xs: 1.5,
                                  md: 3,
                                }}
                                alignItems="center"
                              >
                                {controlInfo?.catalogPartner?.toLowerCase() ==
                                  "buymore" && !isEdit ? (
                                  <>
                                    <Grid item xs={12} md={3.2}>
                                      <SelectWithLabel
                                        label="Select Warehouse"
                                        menuList={buymoreWarehouseInfoList}
                                        value={
                                          selectedWarehouse?.label ||
                                          "Select Warehouse"
                                        }
                                        returnFullItem
                                        valueSelector="value"
                                        onValueChange={(value) => {
                                          setSelectedWarehouse(value);
                                          setControlInfo((prevState) => ({
                                            ...prevState,
                                            facilityName:
                                              value?.code != -1
                                                ? value?.label
                                                : "",
                                            facilityCode:
                                              value?.code != -1
                                                ? value?.code
                                                : "",
                                          }));

                                          setIsFacilityCodeValid(
                                            value?.code != -1
                                          );
                                        }}
                                        errorMsg={
                                          controlInfo?.errors?.catalogPartner
                                        }
                                        disabled={isSubBranch}
                                      />
                                    </Grid>

                                    {isFacilityCodeValid && (
                                      <Grid item xs={10} md={2}>
                                        <Box mb={-4}>
                                          <VerifyBtn
                                            isVerified={isFacilityCodeValid}
                                            handleVerifyClick={() => {}}
                                            isLoading={verifyLoader}
                                          />
                                        </Box>
                                      </Grid>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {isFacilityCodeValid && (
                                      <Grid item xs={10} md={3.2}>
                                        <FormInputBox
                                          label="Facility/Warehouse Name"
                                          placeholder=""
                                          value={controlInfo?.facilityName}
                                          onChange={({ target }) => {
                                            handleSetValue(
                                              "facilityName",
                                              target?.value
                                            );
                                          }}
                                          disabled
                                          error={
                                            controlInfo?.errors?.facilityName
                                          }
                                          autoComplete="off"
                                        />
                                      </Grid>
                                    )}

                                    <Grid item xs={10} md={3.2}>
                                      <FormInputBox
                                        label="Facility/Warehouse Code"
                                        placeholder=""
                                        value={controlInfo?.facilityCode}
                                        onChange={({ target }) => {
                                          handleSetValue(
                                            "facilityCode",
                                            target?.value
                                          );
                                        }}
                                        disabled={isFacilityCodeValid}
                                        error={
                                          controlInfo?.errors?.facilityCode
                                        }
                                        autoComplete="off"
                                      />
                                    </Grid>

                                    <Grid item xs={10} md={2}>
                                      <VerifyBtn
                                        isVerified={isFacilityCodeValid}
                                        handleVerifyClick={verifyFacilityInfo}
                                        isLoading={verifyLoader}
                                      />
                                    </Grid>
                                  </>
                                )}
                              </Grid>
                            </Box>
                          </Box>
                        </>
                      )}
                    </>
                  ) : (
                    <ThreeDotLoader />
                  )}
                </Box>

                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Button
                    onClick={() => {
                      const businessUrl =
                        sessionStorage.getItem("costboWEBURL");
                      navigate(`/${businessUrl}/catalogControls`);
                    }}
                    sx={styles.backBtn}
                  >
                    <SkipPreviousIcon fontSize="large" />
                  </Button>

                  <Button
                    onClick={() => {
                      handleSubmit();
                    }}
                    sx={styles.submitBtn}
                    disabled={
                      !isCredentialsVerified ||
                      !isFacilityCodeValid ||
                      isLoading
                    }
                    startIcon={
                      isLoading && (
                        <CircularProgress size={16} color="inherit" />
                      )
                    }
                  >
                    SUBMIT
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        </DashboardLayout>
      ) : (
        <ThreeDotLoader />
      )}
    </Box>
  );
}

export default EditCatalogControls;

const VerifyBtn = ({ isVerified, handleVerifyClick, isLoading }) => {
  return isVerified ? (
    <Box
      display="flex"
      alignItems="center"
      color={greenColor02}
      gap={0.6}
      mb={2}
    >
      <CheckCircleIcon sx={{ fontSize: "20px" }} />
      <Typography fontSize={14} fontWeight={500} color="inherit">
        Verified
      </Typography>
    </Box>
  ) : (
    <Button
      variant="outline"
      disableElevation
      sx={{
        fontSize: 13,
        fontWeight: 500,
        color: blueColor04,
        p: "4px 25px",
        border: `1px solid ${blueColor04}`,
        "&:hover": {
          color: whiteColor,
          bgcolor: blueColor04,
        },
        "&.Mui-disabled": {
          border: "none",
        },
      }}
      disabled={isLoading}
      startIcon={isLoading && <CircularProgress size={16} color="inherit" />}
      onClick={() => {
        handleVerifyClick();
      }}
    >
      VERIFY
    </Button>
  );
};

const styles = {
  container: {
    backgroundColor: BGColor02,
    pb: 2,
  },

  content: {
    display: "flex",
    flexDirection: "column",
    // gap: { xs: "0px", md: "25px" },
  },

  card: {
    backgroundColor: whiteColor,
    borderRadius: { xs: "6px", md: "13px" },
    boxShadow: "0 0px 4px 0 rgb(0 0 0 / 5%)",
    p: "15px 20px 20px 20px",
    m: { xs: "0 0 25px", md: "10px 0 20px" },
  },

  submitBtn: {
    backgroundColor: blackShade22,
    padding: "4px 20px",
    fontSize: "13px",
    fontWeight: 600,
    color: whiteColor,
    border: "1.5px solid " + blackShade22,
    "&:hover": {
      color: blackShade22,
      backgroundColor: whiteColor,
    },

    "&.Mui-disabled": {
      border: "none",
      color: whiteColor,
      bgcolor: greyShade13,
    },
  },

  backBtn: {
    backgroundColor: whiteColor,
    padding: "4px 20px",
    fontSize: "13px",
    fontWeight: 600,
    color: blackShade22,
    border: "1px solid " + blackShade22,
    "&:hover": {
      color: blackShade22,
      backgroundColor: whiteColor,
    },
  },
};
